import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=282cb072&scoped=true"
import script from "./EndScreen.vue?vue&type=script&lang=js"
export * from "./EndScreen.vue?vue&type=script&lang=js"
import style0 from "./EndScreen.vue?vue&type=style&index=0&id=282cb072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cb072",
  null
  
)

export default component.exports